// extracted by mini-css-extract-plugin
export var button = "styles-module__button___nLAOZ";
export var buttonAndTextContainer = "styles-module__buttonAndTextContainer___prhxO";
export var close = "styles-module__close___r6L30";
export var container = "styles-module__container___bPBWS";
export var text = "styles-module__text___sMqjp";